export interface CSVRow {
  [key: string]: string | number | null | undefined;
}

/**
 * Escapes a CSV cell value to handle special characters (commas, quotes, newlines)
 * @param cell - The cell value to escape
 * @returns The escaped cell value
 */
const escapeCsvCell = (cell: string | number | null | undefined): string => {
  const cellStr = cell == null ? "" : String(cell);

  if (
    cellStr.includes(",") ||
    cellStr.includes('"') ||
    cellStr.includes("\n")
  ) {
    return `"${cellStr.replace(/"/g, '""')}"`;
  }

  return cellStr;
};

export const downloadCSV = (rows: string[][], filename: string) => {
  const csvContent = rows
    .map((row) => row.map(escapeCsvCell).join(","))
    .join("\n");
  const BOM = new Uint8Array([0xef, 0xbb, 0xbf]); // UTF-8 BOM for Excel compatibility
  const blob = new Blob([BOM, csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
